if (!customElements.get('completa-el-equipo')) {
  customElements.define(
    'completa-el-equipo',
    class CompletaElEquipo extends HTMLElement {
      constructor() {
        super();

        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onBuyNow = this.onBuyNow.bind(this);
        this.onMainVariantChange = this.onMainVariantChange.bind(this);
        this.onToggleChange = this.onToggleChange.bind(this);
      }

      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.productForm = this.form?.closest('product-form');
        this.submitButton = this.form?.querySelector('[name="add"]');
        this.buyNowButton = document.querySelector(`[data-complete-buy-now="${this.dataset.sectionId}"]`);
        this.toggle = this.querySelector('[data-complete-toggle]');

        this.form?.addEventListener('submit', this.onFormSubmit, true);
        this.buyNowButton?.addEventListener('click', this.onBuyNow);
        this.toggle?.addEventListener('change', this.onToggleChange);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, this.onMainVariantChange);
        }

        this.onToggleChange();
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.onFormSubmit, true);
        this.buyNowButton?.removeEventListener('click', this.onBuyNow);
        this.toggle?.removeEventListener('change', this.onToggleChange);
        this.unsubscribeVariantChange?.();
      }

      onMainVariantChange(event) {
        const eventSectionId = String(event?.data?.sectionId || '');
        if (eventSectionId && eventSectionId !== String(this.dataset.sectionId)) return;

        const variant = event?.data?.variant;
        if (!variant || !this.buyNowButton) return;

        this.buyNowButton.toggleAttribute('disabled', !variant.available);
        this.buyNowButton.setAttribute('aria-disabled', variant.available ? 'false' : 'true');
      }

      onToggleChange() {
        const card = this.querySelector('[data-complete-product]');
        card?.classList.toggle('is-selected', Boolean(this.toggle?.checked));
      }

      onFormSubmit(event) {
        if (!this.toggle?.checked) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.addSelection({ checkout: false });
      }

      onBuyNow(event) {
        event.preventDefault();
        this.addSelection({ checkout: true });
      }

      buildItems() {
        if (!this.form) return [];

        const formData = new FormData(this.form);
        const mainVariantId = Number(formData.get('id') || 0);
        const mainQuantityInput = document.querySelector(
          `[data-main-product-quantity][form="${this.dataset.formId}"]`
        );
        const mainQuantity = Math.max(Number(formData.get('quantity') || mainQuantityInput?.value || 1), 1);
        const properties = {};

        formData.forEach((value, key) => {
          const propertyMatch = key.match(/^properties\[(.+)\]$/);
          if (propertyMatch && value !== '') properties[propertyMatch[1]] = value;
        });

        const mainItem = {
          id: mainVariantId,
          quantity: mainQuantity,
        };

        if (Object.keys(properties).length) mainItem.properties = properties;
        if (formData.get('selling_plan')) mainItem.selling_plan = Number(formData.get('selling_plan'));

        const items = mainVariantId ? [mainItem] : [];
        const complementVariantId = Number(this.toggle?.dataset.variantId || 0);

        if (this.toggle?.checked && complementVariantId) {
          items.push({
            id: complementVariantId,
            quantity: 1,
            properties: {
              _wuftrek_origen: 'Completa el equipo',
              _wuftrek_producto_principal: this.dataset.mainProductTitle || 'No identificado',
              _wuftrek_producto_principal_id: String(this.dataset.mainProductId || ''),
              _wuftrek_producto_principal_handle: this.dataset.mainProductHandle || '',
            },
          });
        }

        return items;
      }

      async addSelection({ checkout }) {
        if (this.isSubmitting) return;

        const items = this.buildItems();
        if (!items.length) return;

        this.clearError();
        this.setLoading(true, checkout);
        this.isSubmitting = true;

        try {
          const miniCart = document.querySelector('mini-cart');
          const sections = !checkout && miniCart
            ? miniCart.getSectionsToRender().map((section) => section.id)
            : [];

          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              items,
              sections,
              sections_url: window.location.pathname,
            }),
          });

          const parsedState = await response.json();
          if (!response.ok || parsedState.status) {
            throw new Error(parsedState.description || parsedState.message || this.dataset.errorMessage);
          }

          if (checkout) {
            window.location.href = this.dataset.checkoutUrl;
            return;
          }

          if (miniCart && parsedState.sections) {
            miniCart.setActiveElement?.(this.submitButton || document.activeElement);
            miniCart.renderContents(parsedState);
          } else if (typeof theme !== 'undefined' && theme.shopSettings?.cartDrawer === false) {
            window.location.href = theme.routes.cart_url;
            return;
          }

          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: parsedState },
            })
          );

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'completa-el-equipo',
              productVariantId: items[0].id,
              cart: parsedState,
              sections,
            });
          }
        } catch (requestError) {
          this.showError(requestError.message || this.dataset.errorMessage || 'No pudimos agregar la selección.');
        } finally {
          if (!checkout || !window.location.href.endsWith(this.dataset.checkoutUrl)) {
            this.setLoading(false, checkout);
            this.isSubmitting = false;
          }
        }
      }

      setLoading(loading, checkout) {
        const activeButton = checkout ? this.buyNowButton : this.submitButton;
        if (!activeButton) return;

        activeButton.toggleAttribute('disabled', loading);
        activeButton.setAttribute('aria-disabled', loading ? 'true' : 'false');
        activeButton.classList.toggle('loading', loading);
        activeButton.classList.toggle('is-loading', loading);
      }

      clearError() {
        const error = this.querySelector('[data-complete-error]');
        if (error) {
          error.hidden = true;
          error.textContent = '';
        }
        this.productForm?.handleErrorMessage?.();
      }

      showError(message) {
        const error = this.querySelector('[data-complete-error]');
        if (error) {
          error.textContent = message;
          error.hidden = false;
        }
        this.productForm?.handleErrorMessage?.(message);
      }
    }
  );
}

/* WUFTREK — Piloto: restricciones de entrada para el parche personalizado */
(() => {
  const PATCH_INPUT_SELECTOR = '[data-wuftrek-patch-text]';
  const PATCH_TYPE_SELECTOR = '[data-wuftrek-patch-type]';

  const getSelectedType = (input) => {
    const root = input.closest('wuftrek-personalized-patch');
    return root?.querySelector(`${PATCH_TYPE_SELECTOR}:checked`)?.value || '';
  };

  const sanitizePatchInput = (input) => {
    const selectedType = getSelectedType(input);

    if (selectedType === 'Nombre') {
      input.value = input.value.replace(/[^\p{L}\s]/gu, '');
      input.inputMode = 'text';
      input.setAttribute('inputmode', 'text');
      input.removeAttribute('pattern');
      return;
    }

    if (selectedType === 'Teléfono') {
      input.value = input.value.replace(/[^0-9 ]/g, '');
      input.inputMode = 'tel';
      input.setAttribute('inputmode', 'tel');
      input.setAttribute('pattern', '[0-9 ]*');
    }
  };

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(PATCH_INPUT_SELECTOR)) return;
    sanitizePatchInput(input);
  });

  document.addEventListener('change', (event) => {
    const typeControl = event.target;
    if (!(typeControl instanceof HTMLInputElement) || !typeControl.matches(PATCH_TYPE_SELECTOR)) return;

    const root = typeControl.closest('wuftrek-personalized-patch');
    const input = root?.querySelector(PATCH_INPUT_SELECTOR);
    if (!(input instanceof HTMLInputElement)) return;

    if (typeControl.value === 'Nombre') {
      input.inputMode = 'text';
      input.setAttribute('inputmode', 'text');
      input.removeAttribute('pattern');
      input.placeholder = 'Ej. Bruno';
    }

    if (typeControl.value === 'Teléfono') {
      input.inputMode = 'tel';
      input.setAttribute('inputmode', 'tel');
      input.setAttribute('pattern', '[0-9 ]*');
      input.placeholder = 'Ej. 300 675 4321';
    }

    sanitizePatchInput(input);
  });
})();

/* WUFTREK — Piloto: cuando hay parche + complemento, usar el complemento realmente marcado */
(() => {
  const applyCompleteLookupFix = () => {
    const PatchElement = customElements.get('wuftrek-personalized-patch');
    if (!PatchElement || PatchElement.prototype.__wuftrekCompleteLookupFixed) return;

    PatchElement.prototype.getCompleteComponent = function getCompleteComponent() {
      const productRoot = this.closest('product-info') || document;
      const completeComponents = Array.from(productRoot.querySelectorAll('completa-el-equipo'));

      const selectedToggle = Array.from(
        productRoot.querySelectorAll('completa-el-equipo [data-complete-toggle]')
      ).find((toggle) => toggle.checked && !toggle.disabled);

      if (selectedToggle) {
        return selectedToggle.closest('completa-el-equipo');
      }

      const formId = String(this.form?.id || this.dataset.formId || '');
      if (formId) {
        const byForm = completeComponents.find(
          (item) => String(item.dataset.formId || '') === formId
        );
        if (byForm) return byForm;
      }

      const productId = String(this.dataset.mainProductId || '');
      if (productId) {
        const byProduct = completeComponents.find(
          (item) => String(item.dataset.mainProductId || '') === productId
        );
        if (byProduct) return byProduct;
      }

      return null;
    };

    PatchElement.prototype.__wuftrekCompleteLookupFixed = true;
  };

  if (customElements.get('wuftrek-personalized-patch')) {
    applyCompleteLookupFix();
  } else {
    customElements.whenDefined('wuftrek-personalized-patch').then(applyCompleteLookupFix);
  }
})();


/* WUFTREK — Piloto: límites de personalización del parche */
(() => {
  const PATCH_INPUT_SELECTOR = '[data-wuftrek-patch-text]';
  const PATCH_TYPE_SELECTOR = '[data-wuftrek-patch-type]';
  const LIMIT_SELECTOR = '[data-wuftrek-patch-limit]';
  const NAME_MAX = 12;
  const PHONE_DIGITS = 10;

  const getSelectedType = (input) => {
    const root = input.closest('wuftrek-personalized-patch');
    return root?.querySelector(`${PATCH_TYPE_SELECTOR}:checked`)?.value || '';
  };

  const ensureLimitMessage = (input) => {
    const root = input.closest('wuftrek-personalized-patch');
    if (!root) return null;

    let message = root.querySelector(LIMIT_SELECTOR);
    if (!message) {
      message = document.createElement('p');
      message.setAttribute('data-wuftrek-patch-limit', '');
      message.setAttribute('aria-live', 'polite');
      message.style.cssText = [
        'margin:5px 0 0',
        'font-family:var(--font-body-family)',
        'font-size:12px',
        'font-weight:400',
        'line-height:1.3',
        'color:rgba(37,37,37,.62)',
        'text-align:right',
      ].join(';');
      input.insertAdjacentElement('afterend', message);
    }

    return message;
  };

  const normalizeName = (value) => {
    const cleaned = value
      .replace(/[^\p{L}\s]/gu, '')
      .replace(/\s{2,}/g, ' ')
      .replace(/^\s+/g, '');

    return Array.from(cleaned).slice(0, NAME_MAX).join('');
  };

  const normalizePhone = (value) => {
    let digits = value.replace(/\D/g, '');

    if (digits.length > PHONE_DIGITS && digits.startsWith('57')) {
      digits = digits.slice(2);
    }

    digits = digits.slice(0, PHONE_DIGITS);

    return [
      digits.slice(0, 3),
      digits.slice(3, 6),
      digits.slice(6, 10),
    ].filter(Boolean).join(' ');
  };

  const updatePatchLimit = (input) => {
    const selectedType = getSelectedType(input);
    const message = ensureLimitMessage(input);
    if (!message) return;

    if (selectedType === 'Nombre') {
      input.value = normalizeName(input.value);
      input.maxLength = NAME_MAX;
      input.inputMode = 'text';
      input.setAttribute('inputmode', 'text');
      input.removeAttribute('pattern');

      const count = Array.from(input.value).length;
      message.textContent = `${count}/${NAME_MAX} caracteres`;
      message.hidden = false;
      return;
    }

    if (selectedType === 'Teléfono') {
      input.removeAttribute('maxlength');
      input.value = normalizePhone(input.value);
      input.inputMode = 'tel';
      input.setAttribute('inputmode', 'tel');
      input.setAttribute('pattern', '[0-9 ]*');

      const count = input.value.replace(/\D/g, '').length;
      message.textContent = `${count}/${PHONE_DIGITS} dígitos`;
      message.hidden = false;
      return;
    }

    input.removeAttribute('maxlength');
    message.hidden = true;
    message.textContent = '';
  };

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(PATCH_INPUT_SELECTOR)) return;
    updatePatchLimit(input);
  });

  document.addEventListener('change', (event) => {
    const typeControl = event.target;
    if (!(typeControl instanceof HTMLInputElement) || !typeControl.matches(PATCH_TYPE_SELECTOR)) return;

    const root = typeControl.closest('wuftrek-personalized-patch');
    const input = root?.querySelector(PATCH_INPUT_SELECTOR);
    if (!(input instanceof HTMLInputElement)) return;

    updatePatchLimit(input);
  });

  const initializePatchLimits = () => {
    document.querySelectorAll(PATCH_INPUT_SELECTOR).forEach((input) => {
      if (input instanceof HTMLInputElement) updatePatchLimit(input);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePatchLimits, { once: true });
  } else {
    initializePatchLimits();
  }

  const applyPatchLimitValidation = () => {
    const PatchElement = customElements.get('wuftrek-personalized-patch');
    if (!PatchElement || PatchElement.prototype.__wuftrekPatchLimitsFixed) return;

    PatchElement.prototype.validateSelection = function validateSelection() {
      const selection = this.getSelection();

      if (!selection.type) {
        this.showError('Elige una sola opción para el parche: Nombre o Teléfono.');
        this.typeInputs?.[0]?.focus();
        return false;
      }

      if (!selection.text) {
        this.showError(
          selection.type === 'Nombre'
            ? 'Escribe el nombre que quieres en el parche.'
            : 'Escribe el teléfono que quieres en el parche.'
        );
        this.input?.focus();
        return false;
      }

      if (selection.type === 'Nombre') {
        const validName = /^[\p{L}\s]+$/u.test(selection.text);
        const characterCount = Array.from(selection.text).length;

        if (!validName || characterCount > NAME_MAX) {
          this.showError(`El nombre puede tener máximo ${NAME_MAX} caracteres, incluidos los espacios.`);
          this.input?.focus();
          return false;
        }
      }

      if (selection.type === 'Teléfono') {
        const validPhone = /^[0-9 ]+$/.test(selection.text);
        const digitCount = selection.text.replace(/\D/g, '').length;

        if (!validPhone || digitCount !== PHONE_DIGITS) {
          this.showError('Escribe un teléfono de 10 dígitos. Ej. 300 123 4567.');
          this.input?.focus();
          return false;
        }
      }

      if (!selection.variantId) {
        this.showError('No pudimos cargar el producto Parche personalizado.');
        return false;
      }

      this.clearError();
      return true;
    };

    PatchElement.prototype.__wuftrekPatchLimitsFixed = true;
  };

  if (customElements.get('wuftrek-personalized-patch')) {
    applyPatchLimitValidation();
  } else {
    customElements.whenDefined('wuftrek-personalized-patch').then(applyPatchLimitValidation);
  }
})();

/* WUFTREK — Piloto: nombre del parche siempre en MAYÚSCULAS */
(() => {
  const PATCH_INPUT_SELECTOR = '[data-wuftrek-patch-text]';
  const PATCH_TYPE_SELECTOR = '[data-wuftrek-patch-type]';

  const isNameSelected = (input) => {
    const root = input.closest('wuftrek-personalized-patch');
    return root?.querySelector(`${PATCH_TYPE_SELECTOR}:checked`)?.value === 'Nombre';
  };

  const forceUppercaseName = (input) => {
    if (!isNameSelected(input)) return;
    input.value = input.value.toLocaleUpperCase('es-CO');
  };

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(PATCH_INPUT_SELECTOR)) return;
    forceUppercaseName(input);
  });

  document.addEventListener('change', (event) => {
    const typeControl = event.target;
    if (!(typeControl instanceof HTMLInputElement) || !typeControl.matches(PATCH_TYPE_SELECTOR)) return;

    const root = typeControl.closest('wuftrek-personalized-patch');
    const input = root?.querySelector(PATCH_INPUT_SELECTOR);
    if (!(input instanceof HTMLInputElement)) return;

    if (typeControl.value === 'Nombre') {
      input.placeholder = 'Ej. MAXI';
      forceUppercaseName(input);
    }
  });
})();
